import Vue from "vue";
import Router from "vue-router";
import routerPublic from "./public/router.js";
import routerAuth from "./user/auth/router.js";
import routerUser from "./user/user/router.js";
import routerCompany from "./company/company/router.js";
import routerFacility from "./facility/facility/router.js";
import routerOps from "./operations/notification/router.js";
import routerRisk from "./business/risk/router.js";
import routerBudget from "./business/budget/router.js";
import routerHazard from "./safety/hazard/router.js";
import routerIncident from "./safety/incident/router.js";
import routerPlan from "./business/plan/router.js";
import routerMaintStrategy from "./maintenance/strategy/router.js";
import routerMaintPlan from "./maintenance/plan/router.js";
import routerMaintCall from "./maintenance/call/router.js";
import routerActions from "./business/actions/router.js";
import routerOrder from "./finance/order/router.js";
import routerWorkRequest from "./work/request/router.js";
import routerWorkCall from "./work/call/router.js";
import routerWorkTool from "./work/tool/router.js";
import routerProcedure from "./work/procedure/router.js";
import routerEngineering from "./engineering/engineering/router.js";
import routerReport from "./engineering/report/router.js";
import routerProgram from "./engineering/program/router.js";
import routerAsset from "./asset/asset/router.js";
import routerEquipment from "./engineering/equipment/router.js";
import routerMaterial from "./logistics/material/router.js";
import routerAdmin from "./admin/router.js";
import routerAccess from "./support/access/router.js";
import routerRegister from "./data/register/router.js";
import routerTree from "./asset/tree/router.js";
import routerFrame from "./frame/router.js";
import routerDocRevs from "./document/revisions/router.js";
import routerDocLog from "./document/log/router.js";

// eslint-disable-next-line
// import Vuex from 'vuex'
// eslint-disable-next-line
import store from "./store.js";
// combine all imported routes into array
let Routes = [];
Routes = Routes.concat(
  routerPublic,
  routerFrame,
  routerAuth,
  routerAdmin,
  routerAccess,
  routerOps,
  routerWorkRequest,
  routerWorkTool,
  routerProcedure,
  routerEngineering,
  routerReport,
  routerEquipment,
  routerMaterial,
  routerMaintStrategy,
  routerMaintPlan,
  routerMaintCall,
  routerRisk,
  routerPlan,
  routerBudget,
  routerHazard,
  routerOrder,
  routerRegister,
  routerTree,
  routerUser,
  routerCompany,
  routerFacility,
  routerAsset,
  routerWorkCall,
  routerDocRevs,
  routerDocLog,
  routerActions,
  routerAsset,
  routerIncident,
  routerProgram
);

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: Routes
});

// Navigational Guards
router.beforeEach((to, from, next) => {
  let tempUser = store.getters.getUser;

  // GENERAL ACCESS (USER IS NOT NULL)
  if (
    to.fullPath === "/appdash" ||
    to.fullPath === "/userdash" ||
    to.fullPath === "/userdetail" ||
    to.fullPath === "/registerlist" ||
    to.fullPath === "/reportlist" ||
    to.fullPath === "/accessdetail" ||
    to.fullPath === "/accesslist" ||
    to.fullPath === "/activitylog"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // BUSINESS (USER IS NOT NULL)
  if (
    to.fullPath === "/riskdetail" ||
    to.fullPath === "/plandetail" ||
    to.fullPath === "/actiondetail" ||
    to.fullPath === "/orderdetail" ||
    to.fullPath === "/budgetdetail"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // MAINT (USER IS NOT NULL)
  if (
    to.fullPath === "/maintstrategydetail" ||
    to.fullPath === "/maintplandetail" ||
    to.fullPath === "/maintcalldetail"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // WORK (USER IS NOT NULL)
  if (
    to.fullPath === "/workrequestdetail" ||
    to.fullPath === "/workcalldetail" ||
    to.fullPath === "/programdetail"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // OPS (USER IS NOT NULL)
  if (to.fullPath === "/opsdetail") {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // HAZARD (USER IS NOT NULL)
  if (
    to.fullPath === "/hazarddetail" ||
    to.fullPath === "/riskdetail" ||
    to.fullPath === "/incidentdetail"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // TECH (USER IS NOT NULL)
  if (
    to.fullPath === "/engineeringdetail" ||
    to.fullPath === "/reportdetail" ||
    to.fullPath === "/equipmentdetail" ||
    to.fullPath === "/materialdetail" ||
    to.fullPath === "/proceduredetail"
  ) {
    if (tempUser !== null) {
      next();
    } else {
      next("/unauthorised");
    }
  }

  // COMPANY ACCESS (USER COMPANY)
  if (
    to.fullPath === "/companydash" ||
    to.fullPath === "/companydetail" ||
    to.fullPath === "/companymanagement" ||
    to.fullPath === "/companydashsafety" ||
    to.fullPath === "/companydashbusiness" ||
    to.fullPath === "/companydashtechnical"
  ) {
    if (tempUser !== null) {
      let auth = tempUser.pref.select.cauth;
      if (auth !== null && auth !== undefined && auth < 9) {
        next();
      } else {
        next("/accesscompany");
      }
    } else {
      next("/unauthorised");
    }
  }

  // FACILITY ACCESS (USER FACILITY)
  if (
    to.fullPath === "/facilitydash" ||
    to.fullPath === "/facilitydetail" ||
    to.fullPath === "/facilitymanagement" ||
    to.fullPath === "/facilitydashmaintenance" ||
    to.fullPath === "/facilitydashoperations" ||
    to.fullPath === "/facilitydashengineering"
  ) {
    if (tempUser !== null) {
      let auth = tempUser.pref.select.fauth;
      if (auth !== null && auth !== undefined && auth < 7) {
        next();
      } else {
        next("/accessfacility");
      }
    } else {
      next("/unauthorised");
    }
  }

  // ASSET PAGES
  if (to.fullPath === "/assetdetail" || to.fullPath === "/treeview") {
    if (tempUser !== null) {
      let auth = tempUser.pref.select.fauth;
      if (auth !== null && auth !== undefined && auth < 9) {
        next();
      } else {
        next("/accessfacility");
      }
    } else {
      next("/unauthorised");
    }
  }

  // FACILITY ACCESS (USER FACILITY)
  if (
    to.fullPath === "/workrequestdetail" ||
    to.fullPath === "/workcalldetail" ||
    to.fullPath === "/worktooldetail"
  ) {
    if (tempUser !== null) {
      let auth = tempUser.pref.select.fauth;
      if (auth !== null && auth !== undefined && auth < 10) {
        next();
      } else {
        next("/accessfacility");
      }
    } else {
      next("/unauthorised");
    }
  }

  // NEXT
  next();
});

export default router;
